/* eslint-disable*/

import AWS from 'aws-sdk';

AWS.config.region = 'eu-west-1';
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: 'eu-west-1:af2fda01-15fa-4d02-9fca-471132b36e6d', // TODO: get from env
  });

export const sendFeedbackMail = (parameters, email) => {
  const params = {
    Destination: {
      ToAddresses: [
        email,
      ],
    },
    Message: {
      Body: { 
        Html: {
          Charset: 'UTF-8',
          Data: parameters.message,
        },
        },
        Subject: {
        Charset: 'UTF-8',
        Data: 'Feedback, tillgänglighet',
        },
      },
    Source: 'aedrenavendale@gmail.com',
    ReplyToAddresses: [
        'aedrenavendale@gmail.com',
    ],
  };

  const sendPromise = new AWS.SES({ apiVersion: '2010-12-01' }).sendEmail(params).promise();
  sendPromise.then(    
    function (data) {
        console.log(data.MessageId);
    }).catch(
        function (err) {
        console.log(err, err.stack);
    });
};

export const sendEmail = (parameters, email) => {
    const subject = 'Ny fråga skickad via välkommen hits webformulär';
    const content = '<div>' + '<h3> En ny fråga har kommit in från välkommen hit </h3>' + '<p><strong> Namn: </strong> ' + parameters.name + '</p>' +
    '<p><strong> Mail: </strong> ' + parameters.mail + '</p>' +
    '<p><strong> Fråga: </strong> ' + parameters.question + '</p></div>';
    const sender ='aedrenavendale@gmail.com'; // TODO: We need standard from mail linked to dewire
    
    const params = {
      Destination: {
        ToAddresses: [
          email,
        ],
      },
      Message: {
        Body: { 
          Html: {
            Charset: 'UTF-8',
            Data: content,
          },
          },
          Subject: {
          Charset: 'UTF-8',
          Data: subject,
          },
        },
      Source: sender,
      ReplyToAddresses: [
          sender,
      ],
    };

    const sendPromise = new AWS.SES({ apiVersion: '2010-12-01' }).sendEmail(params).promise();
    sendPromise.then(    
      function (data) {
          console.log(data.MessageId);
      }).catch(
          function (err) {
          console.log(err, err.stack);
      });
};



// WEBPACK FOOTER //
// ./src/Utils/mailUtil.js